import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec5c5674&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ec5c5674&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5c5674",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec5c5674')) {
      api.createRecord('ec5c5674', component.options)
    } else {
      api.reload('ec5c5674', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec5c5674&scoped=true", function () {
      api.rerender('ec5c5674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coreProduct/coreInventoryAdjust/index.vue"
export default component.exports